<template>
    <div class=" ">
        <v-row class="border-container my-3 mx-3">
            <v-col cols="3" class="py-0 px-0">
				<v-autocomplete
					:items="[]"
					item-text="name"
					item-value="id"
					outlined
					dense
					label="الملفات المالية التي تريد عرضها"
					hide-details
					multiple
				/>
            </v-col>

            <v-col cols="2" class="py-0">
				<v-autocomplete
					:items="[]"
					item-text="name"
					item-value="id"
					outlined
					dense
					label="اختر العملة"
					hide-details
				/>
            </v-col>

            <v-col cols="3" class="py-0">
                <bee-date-input
                    label="من تاريخ"
                    dense
                    hide-details
                    clearable
                    prepend-icon="mdi-calendar"
                    user-menu-picker
                    input-format-order="DD-MM-YYYY"
                    class="w-100"
                ></bee-date-input>
            </v-col>

             <v-col cols="3" class="py-0">
                <bee-date-input
                    label="إلى تاريخ"
                    dense
                    hide-details
                    clearable
                    prepend-icon="mdi-calendar"
                    user-menu-picker
                    input-format-order="DD-MM-YYYY"
                    class="w-100"
                ></bee-date-input>
            </v-col>

			<v-spacer />

			<v-col class="py-0 px-0">
				<v-btn
					type="submit"
					color="info-light-color white--text"
				>
					<v-icon size="20" class="me-1">mdi-magnify</v-icon>
					{{$t('buttons.search')}}
				</v-btn>
			</v-col>
        </v-row>

		<!-- table -->
		<bee-handy-table
			:items="items"
			:headers="headers"
			hide-default-footer
			table-class="mx-4"
		></bee-handy-table>
    </div>
</template>

<script>
export default {
	data() {
		return {
			items: [
				{
					name: 'Beetronix',
					trade: '€12.00',
					operations: '€497.00',
					gainsAndLosses: '€12.00',
					budget: '€12.00'
				},
				{
					name: 'Beetronix',
					trade: '€12.00',
					operations: '€497.00',
					gainsAndLosses: '€12.00',
					budget: '€12.00'
				}
			]
		}
	},
	computed: {
		headers() {
			return [
				{
					text: 'اسم الملف المالي',
					name: 'name',
					value: 'name',
					noInput: true
				}, 
				{
					text: 'المتاجرة',
					name: 'trade',
					value: 'trade',
					noInput: true
				},
				{
					text: 'تشغيل',
					name: 'operations',
					value: 'operations',
					noInput: true
				},
				{
					text: 'أرباح وخسائر',
					name: 'gainsAndLosses',
					value: 'gainsAndLosses',
					noInput: true
				},
				{
					text: 'ميزانية',
					name: 'budget',
					value: 'budget',
					noInput: true
				}
			]
		}
	}

}
</script>
